import { useCallback, useEffect, useRef } from 'react';
import type { BoPhan, KhoHang } from '@/types/schemas';
import { useAuth } from '@/contexts/auth-context';
import { QUERY_KEYS } from '@/constants';
import api from '@/lib/api';

export const useAutoSelectBoPhan = (
  onCellValueChange: (rowUuid: string | undefined, field: string, newValue: unknown) => void
) => {
  const { entity } = useAuth();
  const onCellValueChangeRef = useRef(onCellValueChange);

  useEffect(() => {
    onCellValueChangeRef.current = onCellValueChange;
  }, [onCellValueChange]);

  const fetchBoPhan = async (slug: string, maKho: string) => {
    try {
      const res = await api.get(`/entities/${slug}/erp/${QUERY_KEYS.BO_PHAN}/?search=${maKho}`);
      return (res.data?.results?.[0] as BoPhan | undefined) ?? null;
    } catch {
      return null;
    }
  };

  const handleCellValueChange = useCallback(
    async (rowUuid: string | undefined, field: string, newValue: unknown) => {
      onCellValueChangeRef.current(rowUuid, field, newValue);

      if (field !== 'ma_kho_data') return;

      const maKho = (newValue as KhoHang | null)?.ma_kho;
      const slug = entity?.slug;

      if (!maKho || !slug) {
        onCellValueChangeRef.current(rowUuid, 'ma_bp_data', null);
        return;
      }

      const matched = await fetchBoPhan(slug, maKho);
      onCellValueChangeRef.current(rowUuid, 'ma_bp_data', matched);
    },
    [entity?.slug]
  );

  return handleCellValueChange;
};
